import axios, { AxiosResponse } from 'axios';

export class CommonService {

  private _token: string = '';
  private _clientId: string = '';

  set clientId(value: string) {
    this._clientId = value;
  }

  get clientId(): string {
    return this._clientId;
  }
  set token(value: string) {
    this._token = value;
  }

  get token(): string {
    return this._token;
  }

  protected getServerUrl(): string {
    return process.env.VUE_APP_API_URL || 'https://apps.qreventos.com';
  }

  protected manageError(error: any) {
    if (axios.isAxiosError(error)) {
      const apiError = error.response?.headers["api-error"];
      if (apiError) {
        throw apiError;
      }
      throw error.message;
    } else {
      throw 'Error inesperado [' + error + ']';
    }
  }
}